_         = require('underscore')
Vue       = require('vue/dist/vue')
EventBus  = require('shared/plugins/popups').EventBus

module.exports =
  namespaced: true

  state:
    popupsOrder:  []
    popups:       {}

  mutations:

    _pushPopup: (state, payload) ->
      return if _.isObject(state.popups[payload.key])

      popupsOrder = [].concat(state.popupsOrder)
      popupsOrder.push(payload.key)

      popups = _.extend({}, state.popups)
      popups[payload.key] = payload

      Vue.set state, 'popups', popups
      Vue.set state, 'popupsOrder', popupsOrder

      EventBus.get().$emit('push', payload)

    _popPopup: (state, payload) ->
      return unless _.isObject(state.popups[payload.key])

      popupsOrder = _.without(state.popupsOrder, payload.key)
      popups      = _.omit(state.popups, payload.key)

      Vue.set state, 'popups', popups
      Vue.set state, 'popupsOrder', popupsOrder

      EventBus.get().$emit('pop', payload)

    _ignoreEsc: (state, payload) ->
      return unless _.isObject(state.popups[payload.key])

      Vue.set state.popups[payload.key], 'ignoreEsc', true

  actions:

    show: (context, payload) ->
      return unless _.isString(payload.name) && _.size(payload.name) > 0

      payload.key = [payload.name]
      payload.key.push(payload.id) if _.isString(payload.id) && _.size(payload.id) > 0
      payload.key = payload.key.join('-')

      context.commit('_pushPopup', payload)

    hide: (context, payload) ->
      return unless _.isString(payload.name) && _.size(payload.name) > 0

      payload.key = [payload.name]
      payload.key.push(payload.id) if _.isString(payload.id) && _.size(payload.id) > 0
      payload.key = payload.key.join('-')

      context.commit('_popPopup', payload)

    windowKeyupEsc: (context) ->
      key = _.last(context.state.popupsOrder)
      return unless _.isString(key) && _.size(key) > 0

      data = context.state.popups[key] || {}

      context.commit('_popPopup', data) unless data.ignoreEsc == true

    ignoreEsc: (context, payload) ->
      return unless _.isString(payload.name) && _.size(payload.name) > 0

      context.commit('_ignoreEsc', payload)


// WEBPACK FOOTER //
// ./assets/js/shared/store/popups/index.coffee